"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandsSmsSetTemplatesListCtl = /** @class */ (function (_super) {
    __extends(BrandsSmsSetTemplatesListCtl, _super);
    function BrandsSmsSetTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_sms_action_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sms_action_code; });
        _this.dk_sms_action_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sms_action_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        // public readonly dk_header_text = UIUtils.IProp2Str((o: IBrandSmsSetTemplateItem) => { o.header_text });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        // public readonly dk_images_count = UIUtils.IProp2Str((o: IBrandSmsSetTemplateItem) => { o.images_cnt });
        _this.dk_for_test_sms = UIUtils_1.UIUtils.IProp2Str(function (o) { o.for_test_sms; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandsSmsSetTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BrandsSmsSetTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandsSmsSetTemplatesListCtl.prototype.LoadData = function (Key, onDone) {
        var _this = this;
        webAApi_1.ListBrandSmsSetTemplatesByBrandIdGet.exec({ brand_id: Key }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    sms_action_code: resp.list[i].sms_action_code,
                    sms_action_title: resp.list[i].sms_action_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    //header_text: resp.list[i].header_text,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    //images_cnt: resp.list[i].images_cnt,
                    for_test_sms: resp.list[i].for_test_number
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsSetTemplatesListCtl.prototype.AddGwsSmsTemplate = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandSmsSetTemplate.exec({
            data: {
                brand_id: data.brand_id,
                title: data.title,
                sms_action_code: data.sms_action_code,
                description: data.description,
                app_language_id: data.app_language_id,
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                description: data.description,
                title: data.title,
                sms_action_code: data.sms_action_code,
                sms_action_title: resp.sms_action_title,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                // header_text: data.header_text,
                // images_cnt: 0,
                for_test_sms: ""
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsSetTemplatesListCtl.prototype.EditGwsSmsTemplate = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandSmsSetTemplate.exec({
                data: {
                    sms_set_template_id: data.key,
                    title: data.title,
                    sms_action_code: data.sms_action_code,
                    description: data.description,
                    //  header_text: data.header_text,
                    app_language_id: data.app_language_id,
                }
            }, function (resp) {
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.title = data.title;
                _tmp.sms_action_code = data.sms_action_code;
                _tmp.description = data.description;
                _tmp.sms_action_title = resp.sms_action_title;
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                //_tmp.header_text = data.header_text;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsSmsSetTemplatesListCtl.prototype.DeleteGwsSmsTemplate = function (SmsSetTemplateId, onDone) {
        var _this = this;
        var _tmp = this.getById(SmsSetTemplateId);
        if (_tmp) {
            webAApi_1.DoDeleteBrandSmsSetTemplate.exec({ data: { sms_set_template_id: SmsSetTemplateId } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsSmsSetTemplatesListCtl.prototype.CheckGwsSmsTemplate = function (SmsSetTemplateId, onDone) {
        var _this = this;
        webAApi_1.DoCheckBrandSmsSetTemplate.exec({
            data: {
                sms_set_template_id: SmsSetTemplateId,
            }
        }, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsSetTemplatesListCtl.prototype.GetRawTestJSONData = function (SmsGwsSetId, onDone) {
        var _this = this;
        webAApi_1.DoGetRawBrandSmsSetMockObjectForTest.exec({
            data: {
                sms_set_template_id: SmsGwsSetId
            }
        }, function (resp) {
            if (onDone) {
                onDone(resp.mockup_json_base64);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandsSmsSetTemplatesListCtl.prototype.SetGwsSmsTemplateContent = function (key, tplBase64, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoEditBrandSmsSetTemplateData.exec({ data: {
                    sms_set_template_id: key,
                    template_base64: tplBase64
                } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsSmsSetTemplatesListCtl.prototype.SetGwsSmsTestJSONContent = function (key, testBase64, forTestSms, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoEditBrandSmsSetTestJSONData.exec({ data: {
                    sms_set_template_id: key,
                    for_test_json_b64: testBase64,
                    for_test_number: forTestSms
                } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BrandsSmsSetTemplatesListCtl.prototype.GetGwsSmsTemplateContent = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DetailsBrandSmsSetTemplateDataGet.exec({ sms_set_template_id: key }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone(resp.template_base64, resp.for_test_json_b64);
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandsSmsSetTemplatesListCtl;
}(BaseController_1.BaseController));
exports.BrandsSmsSetTemplatesListCtl = BrandsSmsSetTemplatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/options/BrandsSmsSetTemplateListCtl.ts
// module id = 1032
// module chunks = 0